<section class="sh-dialog__content">
  @if (thesaurusConcept) {
    <h4 class="sh-clear-margin-top">{{ "thesaurus.thesaurus-concept-dialog.translations" | translate }}</h4>
    <dl class="sh-description-list">
      @for (preferredLabel of preferredLabels; track preferredLabel) {
        <dt class="sh-description-list__term">{{ preferredLabel.Lang | titlecase }}</dt>
        <dd class="sh-description-list__details sh-preserve-linebreaks sh-wrap-text">{{ preferredLabel.Label }}</dd>
      }
    </dl>
    <h4>{{ "thesaurus.thesaurus-concept-dialog.alternative-terms" | translate }}</h4>
    <dl class="sh-description-list">
      @if (alternativeLabels.length === 0) {
        <p>-</p>
      }
      @for (langLabels of alternativeLabels; track langLabels) {
        <dt class="sh-description-list__term">{{ langLabels.Lang | titlecase }}</dt>
        <dd class="sh-description-list__details sh-preserve-linebreaks sh-wrap-text">
          @for (label of langLabels.Labels; track label) {
            {{ label }}<br />
          }
        </dd>
      }
    </dl>
  }
</section>
